export function getItem(key) {
  const item = window.sessionStorage.getItem(key)
  return item == null ? null : JSON.parse(item)
}

export function setItem(key, value) {
  window.sessionStorage.setItem(key, JSON.stringify(value))
}

export function clear(key) {
  if (key) {
    window.sessionStorage.removeItem(key)
  } else {
    window.sessionStorage.clear()
  }
}
